import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { WorkspaceBreadcrumbs } from '@/features/workspaces/components/workspace-breadcrumbs';
import { createFileRoute } from '@tanstack/react-router';
import { BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import {
  Header,
  HeaderChatButton,
  HeaderBackButton,
  HeaderNextNavButton,
  HeaderNav,
  HeaderPrevNavButton,
  useHeaderNav,
} from '@/ui/components/header';
import { clauseSubcategoryQuery } from '@/features/clauses/queries';
import { ClausesDetailPage } from '@/features/clauses/components/clauses-detail-page';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useFilteredClauses } from '@/features/clauses/helpers';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/(main)/clauses/$subcategoryId/$clauseId',
)({
  staticData: { chatSurface: 'clause_scanner' },
  component: RouteComponent,
});

function RouteComponent() {
  const { workspaceId, projectId, subcategoryId, clauseId } = Route.useParams();
  const workspace = useWorkspace();
  const { data: subCategory } = useSuspenseQuery(
    clauseSubcategoryQuery(workspace.type, workspaceId, subcategoryId),
  );
  const filteredClauses = useFilteredClauses(subcategoryId);

  const { handlePrevious, handleNext, isPreviousDisabled, isNextDisabled } = useHeaderNav(
    filteredClauses,
    clauseId,
    (id) => ({
      to: '/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId/$clauseId',
      params: { projectId, workspaceId, subcategoryId, clauseId: id },
    }),
  );

  return (
    <>
      <Header>
        <HeaderBackButton
          to="/project/$projectId/workspaces/$workspaceId/clauses"
          params={{ projectId, workspaceId }}
        />
        <WorkspaceBreadcrumbs>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/clauses"
            params={{ projectId, workspaceId }}
          >
            {t({ en: 'Clauses', nb: 'Klausuler' })}
          </BreadcrumbLink>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId/clauses/$subcategoryId"
            params={{ projectId, workspaceId, subcategoryId }}
          >
            <span className="line-clamp-1">{subCategory.name}</span>
          </BreadcrumbLink>
          <BreadcrumbPage className="tabular-nums">
            #{subCategory.clauses.find((clause) => clause.id === clauseId)?.displayNumber}
          </BreadcrumbPage>
        </WorkspaceBreadcrumbs>
        <HeaderNav>
          <HeaderPrevNavButton onClick={handlePrevious} disabled={isPreviousDisabled} />
          <HeaderNextNavButton onClick={handleNext} disabled={isNextDisabled} />
        </HeaderNav>
        <HeaderChatButton />
      </Header>
      <ClausesDetailPage />
    </>
  );
}
